"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _AddChildPropsContext = _interopRequireDefault(require("../utils/_AddChildPropsContext"));
var _excluded = ["children", "hide", "replaceWith", "overflowOrder", "sm", "md", "lg", "xl"];
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var ToolbarLayout = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var addChildProps = (0, _react.useContext)(_AddChildPropsContext.default);
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(ToolbarLayout, _props)) : _props;
  var children = props.children,
    hide = props.hide,
    replaceWith = props.replaceWith,
    overflowOrder = props.overflowOrder,
    sm = props.sm,
    md = props.md,
    lg = props.lg,
    xl = props.xl,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hide && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    ref: ref
  }), replaceWith || children));
});
ToolbarLayout.displayName = 'ToolbarLayout';
ToolbarLayout.propTypes = {
  /** Collection of React components to be placed in the layout region.
   * Overflow and responsive replacement behavior will be applied to all children
   * as a whole.
   */
  children: _propTypes.default.node,
  /** Custom classes to add to the **Toolbar** enclosing `<div>` tag. */
  className: _propTypes.default.string,
  /** @ignore, set by Toolbar */
  hide: _propTypes.default.bool,
  /** @ignore, set by Toolbar */
  replaceWith: _propTypes.default.node,
  /** The order of this layout in the overflow menu.
   * Use a unique number for each layout.
   * Items will be displayed in ascending overflowOrder. */
  overflowOrder: _propTypes.default.number,
  /** Behavior for small size. Can be:
   *
   *  * `'hide'`: string indicating this layout section should hide at small sizes.
   *  * `'overflow'`: string indicating this layout section should overflow at small sizes.
   *  * `React.node`: indicating the layout should be replaced with given node at small sizes.
   */
  sm: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /** Behavior for medium size. Can be:
   *
   *  * `'hide'`: string indicating this layout section should hide at medium sizes.
   *  * `'overflow'`: string indicating this layout section should overflow at medium sizes.
   *  * `React.node`: indicating the layout should be replaced with given node at medium sizes.
   */
  md: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /** Behavior for large size. Can be:
   *
   *  * `'hide'`: string indicating this layout section should hide at large sizes.
   *  * `'overflow'`: string indicating this layout section should overflow at large sizes.
   *  * `React.node`: indicating the layout should be replaced with given node at large sizes.
   */
  lg: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /** Behavior for extra-large size. Can be:
   *
   *  * `'hide'`: string indicating this layout section should hide
   *  at extra-large sizes.
   *  * `'overflow'`: string indicating this layout section should overflow at extra-large sizes.
   *  * `React.node`: indicating the layout should be replaced with given node
   *  at extra-large sizes.
   */
  xl: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
};
var _default = ToolbarLayout;
exports.default = _default;